import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { LoadingButton } from '@mui/lab';
import { Button, DialogTitle, ListItemIcon, Paper, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { CommonHelper } from 'src/utils/commonHelper';

const LinkedInPageAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const [isLoadingOn, setLoadingOn] = useState(false);
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  const handleConnectLinkedInPage = () => {
    setLoadingOn(true);
    props.handleConnectLinkedInPage();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title">
        <Typography gutterBottom variant="h4">
          {props.reAuth
            ? `${translate('integration.linkedin.reauthenticate_linkedin_page')}`
            : `${translate('integration.linkedin.do_you_have_linked_page')}?`}
        </Typography>
        {(!isCustomDomain || isPortalAdmin) && (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Button
              variant="outlined"
              startIcon={<YouTubeIcon />}
              onClick={() => window.open('https://www.youtube.com/watch?v=e5hkxC96HuQ', '_blank')}
              color="primary"
            >
              {translate('common.tutorial')}
            </Button>
          </Box>
        )}
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ mx: 'auto', fontWeight: 'bold' }}>
          {props.reAuth
            ? `${translate('common.verify_these_requirements')}:`
            : `${translate('common.make_sure_completed_steps')}:`}
        </Typography>
        <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
          <ListItemIcon>
            <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
          </ListItemIcon>
          <Typography variant="body1">
            {props.reAuth
              ? `${translate('integration.linkedin.linkedin_admin_permissions')}`
              : `${translate('integration.linkedin.admin_linkedin_page')}`}
          </Typography>
        </Paper>
        <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
          <ListItemIcon>
            <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
          </ListItemIcon>
          <Typography variant="body1">
            {props.reAuth
              ? `${translate('integration.linkedin.reconnecting_linkedin_page')}`
              : `${translate('integration.linkedin.create_linkedin_page')}`}
          </Typography>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={() => {
            handleConnectLinkedInPage();
          }}
        >
          {props.reAuth ? `${translate('common.reconnect')}` : `${translate('common.connect')}`}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default LinkedInPageAuthorizationModal;
